module.exports = __webpack_public_path__ + "static/media/emma-and-grace-1.13b8b5e9.jpg";